import React, { useState } from 'react'
import { Form, InjectedFormProps } from 'redux-form'
import { Container } from 'components/Layout'
import { Dots, Dot } from 'components/Dots'
import { SelectPlanType } from './SelectPlanType'
import { SummaryStep } from './SummaryStep'
import sMarg from 'styles/modules/margins.scss'
import useMount from 'react-use/lib/useMount'

import { IPhoneSystemFormData, IPhoneSystemFormContainerProps } from './PhoneSystemForm.container'
import { useCreatePhoneSystemMutation } from 'src/generated/graphql'
import BillingAccountLinkStep from 'features/Billing/BillingAccountLinkStep'
import { SelectDidNumbersStep } from './SelectDidNumbersStep'
import { random } from 'lodash'

export type IPhoneSystemFormProps = InjectedFormProps<IPhoneSystemFormData> &
  IPhoneSystemFormContainerProps & {
    formData: IPhoneSystemFormData
  }

export const PhoneSystemFormComponent = (props: IPhoneSystemFormProps) => {
  const {
    handleSubmit,
    formData,
    change,
    productName,
    submitting,
    onAfterSubmit,
    setHeadings,
  } = props

  const [step, setStep] = useState(1)

  const [createPhoneSystemMutation] = useCreatePhoneSystemMutation()

  useMount(() => {
    if (formData.productName !== productName) {
      change('productName', productName)
      setStep(1)
    }
    change('lastEdited', new Date())
  })

  const submit = async (data: IPhoneSystemFormData) => {
    if (step === 4) {
      await createPhoneSystemMutation({
        variables: {
          name: `${data.plan?.name!} - ${random(0, 100, false)}`,
          ban: data.ban!,
          usagePlanAlias: data.productName!,
          didNumbers: data.didNumbers!.map(item => item.number),
        },
      })
      await onAfterSubmit()
    } else {
      setStep(step + 1)
    }
  }
  const prevStep = () => {
    setStep(step - 1)
  }

  const getStep = () => {
    const commonProps = {
      prev: prevStep,
      formData,
      change,
      setHeadings,
    }

    switch (step) {
      case 1:
        return <SelectPlanType {...commonProps} />
      case 2:
        return <BillingAccountLinkStep {...commonProps} />
      case 3:
        return <SelectDidNumbersStep {...commonProps} />
      case 4:
        return <SummaryStep {...commonProps} submitting={submitting} />
    }
  }

  return (
    <Container paddingTop paddingBottom className="sm">
      <Form onSubmit={handleSubmit(submit)}>
        <Dots className={sMarg.mb60to30}>
          <Dot active={step === 1} />
          <Dot active={step === 2} />
          <Dot active={step === 3} />
          <Dot active={step === 4} />
        </Dots>
        {getStep()}
      </Form>
    </Container>
  )
}



// WEBPACK FOOTER //
// src/features/PhoneSystem/PhoneSystemForm/PhoneSystemForm.tsx